import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Discussions_ds_storage_discussionsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { entity_name?: string, entity_id?: string, discussion?: string, application_id?: string, read_on?: string, $top?: number, $skip?: number }): Promise<{ result?: { id?: string, entity_name?: string, entity_id?: string, reference?: string, discussion?: string, created_by?: string, created_on?: string, read_on?: string, alerted_on?: string, application_id?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/Discussions/datasources/ds_storage_discussions/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { entity_name?: string, entity_id?: string, discussion?: string, application_id?: string, read_on?: string, $keys: string[] }): Promise<{ result?: { id?: string, entity_name?: string, entity_id?: string, reference?: string, discussion?: string, created_by?: string, created_on?: string, read_on?: string, alerted_on?: string, application_id?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Discussions/datasources/ds_storage_discussions/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      entity_name?: string, entity_id?: string, discussion?: string, application_id?: string, read_on?: string    }) {
      return false;
    }
}
